import { render, staticRenderFns } from "./PPI.vue?vue&type=template&id=f9a68092&"
import script from "./PPI.vue?vue&type=script&lang=js&"
export * from "./PPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports